import { call, put, takeEvery } from "redux-saga/effects";
import { gioHocRangBuocApi } from "../../../api/category/gioHocRangBuocApi";
import { IGioHocRangBuoc } from "../../../model/respone/category/IGioHocRangBuoc";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eGioHocRangBuocActionIds,
  IGioHocRangBuocActionTypes,
} from "../../action-types/category/IGioHocRangBuocActions";
import { rootActions } from "../../actions/rootActions";
const mainAction = rootActions.category.gioHocRangBuoc;

export function* gioHocRangBuocSaga(): any {
  yield takeEvery(eGioHocRangBuocActionIds.LOAD_START, loadWorker);
  yield takeEvery(eGioHocRangBuocActionIds.SAVE_START, saveWorker);
  yield takeEvery(eGioHocRangBuocActionIds.DELETE_START, deleteWorker);
}
function* loadWorker(): any {
  const res: IBaseRespone = yield call(gioHocRangBuocApi.SelectAll);
  if (res.is_success) {
    yield put(mainAction.LOAD_SUCCESS(res.data));
  } else {
    yield put(mainAction.LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}
function* saveWorker(action: IGioHocRangBuocActionTypes): any {
  const payload = action.payload as IGioHocRangBuoc;
  let res: IBaseRespone;
  // Risk 5: PK = ID uppercase
  if (payload.ID > 0) {
    res = yield call(gioHocRangBuocApi.Update, payload);
  } else {
    res = yield call(gioHocRangBuocApi.Insert, payload);
  }
  if (res.is_success) {
    yield put(mainAction.SAVE_SUCCESS(res.data));
  } else {
    yield put(mainAction.SAVE_ERRR(res.message ?? "Có lỗi"));
  }
}
function* deleteWorker(action: IGioHocRangBuocActionTypes): any {
  const res: IBaseRespone = yield call(gioHocRangBuocApi.Delete, action.payload as number);
  if (res.is_success) {
    yield put(mainAction.DELETE_SUCCESS(res.data));
  } else {
    yield put(mainAction.DELETE_ERRR(res.message ?? "Có lỗi"));
  }
}
